import request from '@/utils/request'

// 获取栏目树
export function getTreeList(platformId) {
  return request({
    url: '/system/sysBaseParam/getOneUniCode/piyao_information_type',
    method: 'get'
  })
}

// 获取栏目详情
export function getColumnDetail(data) {
  return request({
    url: '/api/column/details?columnId=' + data,
    method: 'post'
  })
}

// 导航栏
export function getNavigation() {
  return request({
    url: '/system/sysBaseParam/getOneUniCode/piyao_information_type',
    method: 'get'
  })
}

// footer

export function getFooter() {
  return request({
    url: '/api/basic/parameters/getFootPage',
    method: 'post'
  })
}

export function getAdvert() {
  return request({
    url: `/common/slider/getList`,
    method: 'post',
    data: {
      type: 16
    }
  })
}

// 文章列表
export function getArticleList(data) {
  return request({
    url: '/information/vInformation/getPageList',
    method: 'post',
    // headers: {
    //   'content-type': 'application/x-www-form-urlencoded'
    // },
    data
  })
}
// 栏目列表

export function columnList(data) {
  return request({
    url: '/api/navigation/single?name=' + data,
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    }

  })
}
// 文章详情
export function getContent(data) {
  return request({
    url: '/information/vInformation/getOneById/' + data.id,
    method: 'get'
  })
}
// 搜索文章
export function searchPageList(data) {
  return request({
    url: '/information/vInformation/getPageList',
    method: 'POST',
    data
  })
}
